// extracted by mini-css-extract-plugin
export default {"wrapper":"WelcomeBlock_wrapper__XhZDs","title":"WelcomeBlock_title__hvKOY","text":"WelcomeBlock_text__XZ4xK","img":"WelcomeBlock_img__f3ghT","ani":"WelcomeBlock_ani__jkD4X"};